var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "stepBody" },
      [
        _vm.showStep
          ? [
              _c(
                "div",
                { attrs: { id: "removeLeft" } },
                [
                  _c(
                    "van-steps",
                    {
                      attrs: {
                        active: _vm.activeTag,
                        activeColor: "#E12817",
                        activeIcon: _vm.activeIcon,
                        "finish-icon": "checked",
                        inactiveIcon: _vm.inactiveIcon
                      },
                      model: {
                        value: _vm.currentIndex,
                        callback: function($$v) {
                          _vm.currentIndex = $$v
                        },
                        expression: "currentIndex"
                      }
                    },
                    _vm._l(_vm.stepData, function(item, index) {
                      return _c(
                        "van-step",
                        { key: index, class: "notStyle" + index },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ]
          : _vm._e()
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "normalStyle", attrs: { id: "centerCont" } },
      [_c("router-view")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }